module.exports = __webpack_public_path__ + "images/mmm-faq-02-desktop.png";